<template>
  <div class="trustpilot-widget" data-locale="en-US" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="5417fd6300006400057a59ec" :data-style-height="height" :data-style-width="width" data-theme="light" data-font-family="Nunito">
    <a href="https://www.trustpilot.com/review/www.lendio.com" target="_blank" rel="noopener">
      <span class="signal powered-by-trustpilot">
        <span class="title">Powered By</span>
        <NuxtImg src="/images/marketplace/trustpilot-logo-new.svg" alt="TrustPilot" />
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'TrustpilotWidget',
  props: ['width', 'height'],
  setup() {
    useHead({
      script: [
        {
          key: 'trustpilot',
          src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
          async: true,
          defer: true
        }
      ]
    }, { mode: 'client' })
  }
}
</script>

<style lang="scss" scoped>
span {
  color: $type-500;
}
</style>
